<template>
  <base-material-alert
    v-if="signMessage"
    color="softInfo"
    class="mb-7"
    :class="{
      'secondary--text': !$vuetify.theme.dark,
      'white--text': $vuetify.theme.dark,
    }"
  >
    <span class="sign-card-message">
      {{ $t(`views.sign.${signMessage}`) }}
    </span>
  </base-material-alert>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['signMessage']),
  },
}
</script>

<style lang="scss">
.sign-card-message {
  font-size: 14px !important;
  font-weight: 300 !important;
}
</style>
